import {
  analyticsProductsKeys,
  experienceProductsKeys,
  offerProductsKeys,
} from "@src/api/queryKeys";
import { queryClient } from "@src/queryClient";
import type { AppListenerMiddleware } from "@src/store/rootState";
import { selectedExperience } from "@src/store/slices/experiences/index";
import { sendWebsocketMessage } from "@src/store/slices/global";

export function setupExperiencesListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: sendWebsocketMessage,
    effect: async (action, { getState }) => {
      if (
        action.payload.type === "processUpdate" &&
        action.payload.process.type === "putExperience" &&
        action.payload.action === "end"
      ) {
        const experience = selectedExperience(getState());
        if (experience?.id) {
          await Promise.all([
            queryClient.invalidateQueries({
              queryKey: experienceProductsKeys.one(action.payload.process.id),
            }),
            queryClient.invalidateQueries({
              queryKey: offerProductsKeys.one(action.payload.process.id),
            }),
            queryClient.invalidateQueries({
              queryKey: analyticsProductsKeys.one(action.payload.process.id),
            }),
          ]);
        }
      }
    },
  });
}
